import Api from '@/services/api.js';

export default class Log {
	reportErro(obj) {
		let objetoLog = {
			intIdTipoLog: 1,
			intSistema: 7,
			strUrl: window.location.href,
			strIP: obj.strIP,
			strTipoErro: obj.strTipoErro,
			strAgente: navigator.userAgent,
			strMetodoHttp: obj.strMetodoHttp,
			intIdUsuario: obj.intIdUsuario,
			strNomeUsuario: obj.strNomeUsuario,
			intIdItem: obj.intIdItem,
			strUrlReferencia: obj.strUrlReferencia,
		};

		// this.sendReport(objetoLog);
	}

	reportAcesso(obj) {
		let objetoLog = {
			intIdTipoLog: 2,
			intSistema: 7,
			strTipoLog: 'Acesso',
			strUrl: obj.strUrl,
			strIP: obj.strIP,
			strAgente: navigator.userAgent,
			strUrlReferencia: window.location.href,
			strMetodoHttp: obj.strMetodoHttp,
			intIdUsuario: obj.intIdUsuario,
			strNomeUsuario: obj.strNomeUsuario,
			intIdItem: obj.intIdItem,
			intIdFerramenta: obj.intIdFerramenta,
			strObjetoClick: obj.strObjetoClick,
			strDestinoClick: obj.strDestinoClick,
			intIdTipoAcao: obj.intIdTipoAcao,
			strTipoAcao: obj.strTipoAcao,
			blAcessoAutorizado: true,
		};

		// this.sendReport(objetoLog);
	}

	reportLogin(obj) {
		let objetoLog = {
			intIdTipoLog: 3,
			intSistema: 7,
			strTipoLog: 'AcessoLogin',
			blTentativaInvasao: false,
			intIdItem: null,
			strUrlReferencia: null,
			strUrl: window.location.href,
			strIP: obj.strIP,
			strAgente: navigator.userAgent,
			strMetodoHttp: obj.strMetodoHttp,
			intIdUsuario: obj.intIdUsuario,
			strNomeUsuario: obj.strNomeUsuario,
			strLogin: obj.strLogin,
			strSenha: obj.strSenha,
			blAcessoSistema: obj.blAcessoSistema,
			blAcessoAutorizado: true,
			intTentativa: obj.intTentativa,
			intIdItem: null,
			strUrlReferencia: '',
		};

		this.sendReport(objetoLog);
	}

	reportSimularAcesso(obj) {
		let objetoLog = {
			intIdTipoLog: 4,
			intSistema: 7,
			strUrl: window.location.href,
			strIP: obj.strIP,
			strAgente: navigator.userAgent,
			strMetodoHttp: obj.strMetodoHttp,
			intIdUsuario: obj.intIdUsuario,
			strNomeUsuario: obj.strNomeUsuario,
			intIdUsuarioSimulado: obj.intIdUsuarioSimulado,
			strNomeUsuarioSimulado: obj.strNomeUsuarioSimulado,
		};

		// this.sendReport(objetoLog);
	}

	reportPesquisa(obj) {
		let objetoLog = {
			intIdTipoLog: 5,
			intSistema: 7,
			strTipoLog: 'Pesquisa',
			strUrl: "Cenario/obterResultados",
			strIP: obj.strIP,
			strAgente: navigator.userAgent,
			strMetodoHttp: 'POST',

			origem: obj.origem,
			destino: obj.destino,
			pais_origem: obj.pais_origem,
			pais_destino: obj.pais_destino,

			operacao: obj.operacao,

			remetente: obj.remetente,
			tipo_atividade_remetente: obj.tipo_atividade_remetente,
			regime_remetente: obj.regime_remetente,
			cnae_remetente: obj.cnae_remetente,
			cnpj_remetente: obj.cnpj_remetente,

			destinatario: obj.destinatario,
			tipo_atividade_destinatario: obj.tipo_atividade_destinatario,
			regime_destinatario: obj.regime_destinatario,
			cnae_destinatario: obj.cnae_destinatario,
			cnpj_destinatario: obj.cnpj_destinatario,

			origem_mercadoria: obj.origem_mercadoria,
			destinacao: obj.destinacao,

			extrapolado: null,
			blAcessoAutorizado: true,
			strNomeUsuario: obj.strNomeUsuario,
			intIdItem: null,
			strUrlReferencia: window.location.href,
			intIdUsuario: obj.intIdUsuario,
			ncm: obj.ncm,
		};

		// this.sendReport(objetoLog);
	}

	sendReport(objetoLog) {
		new Api().post('Tools/log', objetoLog);
	}
}
